<template>
  <div
    class="cursor-pointer text-gray-500"
    :disabled="is_disabled || null"
    @click="submit"
  >
    <a>
      <div v-if="is_collapse">
        <AppIcon
          class="mr-1"
          :name="row_collapsed ? 'solid-plus' : 'solid-minus'"
        />
        {{ row_collapsed ? button_text.expand : button_text.collapse }}
      </div>
      <div v-else>
        <slot />
      </div>
    </a>
  </div>
</template>

<script setup>
const props = defineProps({
  button_text: { type: Object, default: () => ({}) },
  is_disabled: { type: Boolean },
  is_collapse: { type: Boolean },
  row_collapsed: { type: Boolean },
});

const emit = defineEmits(['on-click']);

function submit() {
  if (props.is_disabled) return;
  emit('onClick');
}
</script>
